const API_URL = import.meta.env.VITE_API_URL || '';

class ApiService {
  // Projects
  async getProjects(category = null) {
    try {
      const url = category 
        ? `${API_URL}/api/projects?category=${category}`
        : `${API_URL}/api/projects`;
      
      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch projects');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching projects:', error);
      // Fallback to local JSON if API fails
      try {
        const localData = await import('../data/projectsData.json');
        return localData.default;
      } catch (fallbackError) {
        console.error('Failed to load fallback data:', fallbackError);
        return { BRANDING: [], Marketing: [], Advertising: [] };
      }
    }
  }

  async getProjectById(id) {
    try {
      const response = await fetch(`${API_URL}/api/projects/${id}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch project');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  }

  // Auth
  async login(credentials) {
    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      return data.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  }

  async verifyToken(token) {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Token verification failed');
      }

      return data.data;
    } catch (error) {
      console.error('Error verifying token:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService();
export default apiService;

